package kz.dentalcrm.app.screens.patients.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface PatientsViewEvent : ViewEvent {
    data object LoadNextPage : PatientsViewEvent
    data object Refresh : PatientsViewEvent
    data class RemovePatient(val patientId: Int) : PatientsViewEvent
    data class OnSearchQueryChanged(val query: String) : PatientsViewEvent
}
